import * as yup from 'yup';
import { useForm, UseFormReturn } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

type UseResetUserPasswordForm = () => UseFormReturn;

export const useResetUserPasswordForm: UseResetUserPasswordForm = () => {
  const resetOwnPasswordFormValidationSchema = yup.object().shape({
    newPassword: yup
      .string()
      .required('New password is required')
      .min(8, 'Password should be at least 8 characters long')
      .matches(/\d/, 'Password should have at least 1 digit')
      .matches(/[A-Z]/, 'Password should have at least 1 uppercase letter')
      .matches(/[a-z].*[a-z]/, 'Password should have at least 1 lowercase letter')
      .matches(/[$&+,:;=?@#|'<>.^*()%!/-]/, 'Password should have at least 1 special character'),
  });

  return useForm({
    resolver: yupResolver(resetOwnPasswordFormValidationSchema),
    mode: 'onChange',
  });
};
